<div *ngIf="type!='yes'" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="close()" mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div *ngIf="type!='yes'">
    <div class="padding-10" fxLayout="row" fxLayoutAlign="center center">
        <span>Do you wish to submit your measurements now?
        </span>
    </div>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button (click)="yesChange('yes')" color="primary" mat-raised-button>Yes I want too</button>
        <button mat-raised-button (click)="close()"> No I will Submit it later</button>
    </div>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <mat-hint align="start">Note : if not submitted you will receive an email requesting you to submit your measurements.
        </mat-hint>
    </div>


</div>

<div [formGroup]="firstFormGroup" *ngIf="type=='yes'">
    <div class="padding-10" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <span>STITCHING OPTIONS
            </span>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <button (click)="close()" mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>

    </div>
    <mat-divider></mat-divider>
    <div fxLayout="column" class="padding-10" fxLayoutAlign="space-around center">
        <mat-hint align="start">* If there is any work or embroidery in blouse then that will come on back side.
        </mat-hint>
        <!-- <mat-hint>[ If you want change, please add details 'INSTRUCTION BOX'. ]
        </mat-hint>
        <mat-hint> * Please Submit Your Apex Point
            Measurement in 'INSTRUCTION BOX'.</mat-hint> -->
        <b>{{sareeKey}}</b>
    </div>
    <div fxLayout="row">
        <div (mouseover)="getImage(0)" fxLayout="row" fxLayoutAlign="center center" fxFlex="40">
            <img style="max-width: 65%;" [src]="image" [alt]="sareeKey">
        </div>
        <div fxFlex>
            <div class="padding-10" style="overflow-x:auto;height: 420px;" fxLayout="column">
                <mat-form-field appearance="outline">
                    <mat-label>Blouse Length</mat-label>
                    <input formControlName="blouseLength" (mouseover)="getImage(1)" matInput>
                    <mat-error *ngIf="firstFormGroup.controls.blouseLength.errors?.required">
                        This Name Already Exists !
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Shoulder</mat-label>
                    <input formControlName="shoulder" (mouseover)="getImage(2)" matInput>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Sleeve Length</mat-label>
                    <input formControlName="sleeveLength" (mouseover)="getImage(3)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Sleeve Style</mat-label>
                    <input formControlName="sleeveStyle" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Around Armhole</mat-label>
                    <input formControlName="aroundArmhole" (mouseover)="getImage(5)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Around Arm</mat-label>
                    <input formControlName="aroundArm" (mouseover)="getImage(6)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Around Bust</mat-label>
                    <input formControlName="aroundBust" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Around Above Waist</mat-label>
                    <input formControlName="aroundAboveWaist" (mouseover)="getImage(7)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Front Neck Depth</mat-label>
                    <input formControlName="frontNeckDepth" (mouseover)="getImage(9)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Front Neck Style</mat-label>
                    <input formControlName="frontNeckStyle" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Back Neck Depth</mat-label>
                    <input formControlName="backNeckDepth" (mouseover)="getImage(11)" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Back Neck Style</mat-label>
                    <input formControlName="backNeckStyle" matInput>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Instruction (if any)</mat-label>
                    <textarea formControlName="instruction" matInput></textarea>
                </mat-form-field>
            </div>

        </div>
    </div>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center">
        <button fxFlexOffset="40" fxFlex color="primary" mat-raised-button>SUMMIT</button>
    </div>
</div>